import {Skeleton as MuiSkeleton} from "@material-ui/lab";
import {Box} from "@material-ui/core";
import React, {FC} from "react";
import {styled} from "@mui/material";

const Skeleton = styled(MuiSkeleton)`
  background-color: #232F3E
`

type PropsType = {
  rows?: number;
}

const TableSkeleton: FC<PropsType> = ({ rows= 6}) => {
  const getRows = () => {
    const elements = []
    for (let i = 1; i <= rows; i++) {
      elements.push(
        <Box mt={2.5} key={i}>
          <Skeleton variant='rect' height={48}/>
        </Box>
      )
    }
    return elements
  }

  return (
    <Box>
      {getRows()}
    </Box>
  )
}

export default TableSkeleton